import React from 'react';

export const font = '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

export function useChrome(colors, narrow) {
  const text = (colors && colors.text) || '#1d1d1f';
  const secondary = (colors && colors.textSecondary) || '#6e6e73';
  const muted = (colors && colors.textMuted) || '#8e8e93';
  const line = (colors && colors.border) || '#e5e5ea';
  const surface = (colors && colors.surface) || '#ffffff';
  const background = (colors && colors.background) || '#f5f5f7';
  return {
    text,
    secondary,
    muted,
    line,
    surface,
    background,
    narrow: Boolean(narrow),
    page: {
      fontFamily: font,
      color: text,
      display: 'flex',
      flexDirection: 'column',
      gap: narrow ? 16 : 20,
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
      paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 24px)',
    },
    panel: {
      background: surface,
      border: `1px solid ${line}`,
      borderRadius: 16,
      padding: narrow ? 16 : 20,
      boxSizing: 'border-box',
    },
    title: {
      fontSize: narrow ? 22 : 28,
      fontWeight: 600,
      letterSpacing: '-0.02em',
      margin: 0,
    },
    sub: {
      margin: '6px 0 0',
      color: secondary,
      fontSize: 15,
      lineHeight: 1.45,
    },
    button: {
      minHeight: 44,
      padding: '0 16px',
      borderRadius: 12,
      border: 'none',
      background: '#1d1d1f',
      color: '#fff',
      fontSize: 16,
      fontWeight: 600,
      fontFamily: font,
      cursor: 'pointer',
    },
    quiet: {
      minHeight: 44,
      padding: '0 16px',
      borderRadius: 12,
      border: `1px solid ${line}`,
      background: surface,
      color: text,
      fontSize: 16,
      fontFamily: font,
      cursor: 'pointer',
    },
    field: {
      width: '100%',
      minHeight: 44,
      borderRadius: 12,
      border: `1px solid ${line}`,
      background: surface,
      color: text,
      fontSize: 16,
      fontFamily: font,
      padding: '0 12px',
      boxSizing: 'border-box',
    },
    area: {
      width: '100%',
      minHeight: 96,
      borderRadius: 12,
      border: `1px solid ${line}`,
      background: surface,
      color: text,
      fontSize: 16,
      fontFamily: font,
      padding: 12,
      boxSizing: 'border-box',
      resize: 'vertical',
    },
    chip: {
      display: 'inline-flex',
      alignItems: 'center',
      minHeight: 28,
      padding: '0 10px',
      borderRadius: 999,
      background: background,
      color: secondary,
      fontSize: 13,
      margin: '4px 6px 0 0',
    },
  };
}

export function Panel({ chrome, title, children }) {
  return (
    <section style={chrome.panel} aria-label={title}>
      {children}
    </section>
  );
}

export function Empty({ chrome, children }) {
  return <p style={{ ...chrome.sub, margin: 0 }}>{children}</p>;
}

export function ErrorText({ children }) {
  return <p style={{ color: '#b42318', margin: 0 }}>{children}</p>;
}

export function labelFor(label) {
  if (label === 'Healthy') return { color: '#1d7a46', background: '#e8f6ee' };
  if (label === 'Slipping') return { color: '#9a6700', background: '#fff6df' };
  return { color: '#b42318', background: '#fdecec' };
}
